export enum DeviceOrientationsEnum {
  LANDSCAPE = 'landscape',
  PORTRAIT = 'portrait',
}
